import React from "react"

import { Controller, FieldError, useFormContext } from "react-hook-form"
import { Box, TextField } from "@material-ui/core"

import { ViewProps } from "./text-field-types"

const TextFieldView = ({
  name,
  label,
  multiline = false,
  rows = 8,
}: ViewProps) => {
  const { control, errors } = useFormContext()

  return (
    <Box mb={2}>
      <Controller
        name={name}
        id={name}
        control={control}
        as={
          <TextField
            disabled={control.formState.isSubmitting}
            label={label}
            error={!!errors[name]}
            helperText={errors[name] && (errors[name] as FieldError).message}
            variant="outlined"
            fullWidth
            margin="dense"
            multiline={multiline}
            rows={rows}
          />
        }
      />
    </Box>
  )
}

export default TextFieldView
